import { getRoleContext, supplierTabIndex, tabIndex, userRoleContext } from "./role-details.constants";
import { RolePermissionType } from "./role-permission-type";

export function hasPermission(user: any, permission: RolePermissionType): boolean {
  return user.rolePermissionTypes.includes(permission);
}

export const getNavLinks = (userInfo: any, hasAccessToFormLifeCycle: boolean, featureDetails?: any) => {
  const roleContext = getRoleContext();
  const homeTab = [{
    label: 'Home',
    link: '/home',
    hasPermission: true,
    index: tabIndex.home,
    icon: 'home'
  }, {
    label: 'Suppliers',
    link: '/search-page',
    hasPermission: true,
    index: tabIndex.suppliers,
    icon: 'person'
  }];
  const dashboardTab = [{
    label: 'Dashboard',
    link: '/dashboard',
    hasPermission: true,
    index: tabIndex.dashboard,
    icon: 'home'
  }];
  switch (roleContext) {
    case userRoleContext.Buyer:
      const buyerTabs = [
        {
          label: 'Groups',
          link: '/groups',
          hasPermission: true,
          index: tabIndex.groups,
          icon: 'groups',
          tourAnchor: 'group-tab'
        },
        {
          label: 'Campaigns',
          link: '/campaign',
          hasPermission: true,
          index: tabIndex.campaigns,
          icon: 'fa-solid fa-people-group',
          isNotRegularIcon: true,
          tourAnchor: 'campaign-tab'
        },
        {
          label: 'Enrollments',
          hasPermission: true,
          index: tabIndex.enrollments,
          isExpanded: false,
          subMenu: [
            { label: 'All Enrollments', isLegacy: false, hasPermission: true, link: '/enrollment/all', icon: 'assessment' },
            { label: 'Campaigns', isLegacy: false, hasPermission: true, link: '/enrollment/campaigns', icon: 'fa-solid fa-filter', isNotRegularIcon: true },
            { label: 'Groups', isLegacy: false, hasPermission: true, link: '/enrollment/groups', icon: 'fa-solid fa-filter', isNotRegularIcon: true },
            { label: 'Suppliers', isLegacy: false, hasPermission: true, link: '/enrollment/suppliers', icon: 'fa-solid fa-filter', isNotRegularIcon: true },
            { label: 'Failed Enrollments', isLegacy: false, hasPermission: true, link: '/enrollment/failedEnrollments', icon: 'fa-solid fa-filter', isNotRegularIcon: true },
          ],
          icon: 'card_membership'
        },
        {
          label: 'Form Management',
          index: tabIndex.formManagement,
          hasPermission: true,
          isExpanded: false,
          subMenu: [
            { label: 'Form Requests', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ViewRequestedForms), link: '/form-management/form-request', icon: 'description' },
            { label: 'Approval Decision', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.Approver) || hasPermission(userInfo, RolePermissionType.ManageApprovalWorkflow), link: '/form-management/approval-decision', icon: 'subtitles' },
            { label: 'Form Lifecycle', isLegacy: false, hasPermission: hasAccessToFormLifeCycle && hasPermission(userInfo, RolePermissionType.Deployments), link: '/form-management/form-lifecycle', icon: 'insert_drive_file' }
          ],
          icon: 'notes'
        },
        {
          label: 'Administration',
          index: tabIndex.administration,
          hasPermission: true,
          isExpanded: false,
          subMenu: [
            { label: 'Email Template', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ModifyAndMaintainEmailTemplates), link: '/administration/email-templates', icon: 'email' },
            { label: 'User and Roles', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageUser), link: '/administration/user-roles', icon: 'group_add' },
            {
              label: 'Settings',
              isLegacy: false,
              hasPermission:
                hasPermission(userInfo, RolePermissionType.ManageGeneralSettings) ||
                hasPermission(userInfo, RolePermissionType.ManageNotifications) ||
                hasPermission(userInfo, RolePermissionType.ManageAttribute) ||
                hasPermission(userInfo, RolePermissionType.ManageFormSets),
              icon: 'settings',
              isExpanded: false,
              subMenu: [
                { label: 'General Settings', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageGeneralSettings), link: '/administration/settings/general-settings', icon: 'settings' },
                { label: 'Banner', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageGeneralSettings), link: '/administration/settings/banner-settings', icon: 'bookmark_outline' },
                { label: 'Notification', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageNotifications), link: '/administration/settings/notification-settings', icon: 'notifications_active' },
                { label: 'Appearance', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageGeneralSettings), link: '/administration/settings/appearance-settings', icon: 'palette' },
                { label: 'Attributes Configuration', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageAttribute), link: '/administration/settings/attributes-configuration-settings', icon: 'local_offer' },
                { label: 'Onboarding Settings', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageGeneralSettings), link: '/administration/settings/onboarding-settings', icon: 'public' },
                { label: 'Form Set Configuration', isLegacy: false, hasPermission: hasPermission(userInfo, RolePermissionType.ManageFormSets), link: '/administration/settings/form-configuration', icon: 'fa-solid fa-file-lines', isNotRegularIcon: true }
              ]
            }
          ],
          icon: 'settings'
        },
        {
          label: 'Reports',
          hasPermission: hasPermission(userInfo, RolePermissionType.RunReports),
          link: '/reports',
          index: tabIndex.reports,
          icon: 'library_books'
        },
      ];
      if (featureDetails.NewDashboard) {
        return [
          ...dashboardTab,
          ...buyerTabs
        ];
      }
      return [
        ...homeTab,
        ...buyerTabs
      ];
    case userRoleContext.Support:
      return [{
        label: 'Home',
        link: '/home',
        hasPermission: true,
        index: tabIndex.home,
        icon: 'home'
      },
      {
        label: 'Campaigns',
        link: '/campaign',
        hasPermission: true,
        index: tabIndex.campaigns,
        icon: 'fa-solid fa-people-group',
        isNotRegularIcon: true,
      },
      {
        label: 'Form Management',
        link: '/form-management',
        hasPermission: true,
        index: tabIndex.formManagement,
        icon: 'notes'
      },
    {
        label: 'FormSet Management',
        link: '/formset-list',
        hasPermission: true,
        index: tabIndex.formsetList,
        icon: 'fa-solid fa-file-lines',
        isNotRegularIcon: true 
      }];
    case userRoleContext.Supplier:
      return [{
        label: 'Home',
        link: '/supplier-home',
        hasPermission: true,
        index: supplierTabIndex.home,
        icon: 'home',
        helpText: 'Your home page with an overview of pending forms and recent activity.'
      },
      {
        label: 'Form Management',
        link: '/form-management',
        hasPermission: true,
        index: supplierTabIndex.formManagement,
        icon: 'notes',
        helpText: 'View and manage forms that have been assigned to your organization.'
      },
      {
        label: 'My Organization',
        link: '/my-organization',
        hasPermission: true,
        index: supplierTabIndex.myOrganization,
        icon: 'domain',
        helpText: 'View and manage your organization profile and user accounts.'
      },
      {
        label: 'My Links',
        link: '/my-links',
        hasPermission: true,
        index: supplierTabIndex.myLinks,
        icon: 'link',
        helpText: 'Quick access to application links associated with your organization.'
      },
      {
        label: 'Communications',
        link: '/communications',
        hasPermission: true,
        index: supplierTabIndex.communications,
        icon: 'chat',
        helpText: 'View messages and communications from your buyers.'
      }
    ];
    default:
      return [];
  }

};

export const getExostarDetails = (userInfo: any) => [];